export const PLAN_TIERS = [
  {
    key: "starter",
    lookup_key: "starter_monthly",
    name: "Starter",
    price: "3,99",
    quota: "2 SaaS par mois",
    features: [
      "2 générations de blueprints complets",
      "Design & palette de couleurs IA",
      "Schéma de base de données inclus",
      "Endpoints API & auth spécifiés",
      "Exportation JSON du blueprint",
    ],
    cta: "Choisir Starter",
    popular: false,
  },
  {
    key: "pro",
    lookup_key: "pro_monthly",
    name: "Pro",
    price: "13,99",
    quota: "8 SaaS par mois",
    features: [
      "8 générations mensuelles",
      "Stack technique personnalisable",
      "Roadmap MVP en 5 étapes",
      "Intégration Stripe détaillée",
      "Support prioritaire",
    ],
    cta: "Passer Pro",
    popular: true,
  },
  {
    key: "premium",
    lookup_key: "premium_monthly",
    name: "Premium",
    price: "39,99",
    quota: "Générations illimitées",
    features: [
      "Générations illimitées",
      "Fine-tuning IA de vos préférences",
      "Multi-tenancy & rôles spécifiés",
      "Webhooks Stripe & abonnements",
      "Accompagnement dédié",
    ],
    cta: "Passer Premium",
    popular: false,
  },
];
